module.exports = __webpack_public_path__ + "static/media/mission-failed.94803c38.png";